<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">
    
      <div v-for="n in total" v-bind:key="n">
        <goal-form v-model="goals[n-1].text" :n="n" ref="goalForms"></goal-form>
      </div>
    
  </form-wrapper>
</template>

<script>
import goalForm from "./goal";
import { mapActions, mapState } from "vuex";
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {
      total: 5
    };
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    asuriteId: {
      type: String,
      required: false
    }
  },

  components: {
    "goal-form": goalForm,
    "form-wrapper": formWrapper
  },

  computed: {
    ...mapState({
      goals: state => state.additionalMaterials.goals,
      userId: state => state.additionalMaterials.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId
    })
  },
  methods: {
    ...mapActions("goals", ["createGoals", "emptyGoals"]),
    handleInput: function() {
      this.returnItem();
    },
    validate: function() {
      this.$v.$touch();
      this.returnItem();
    },
    returnItem: function() {
      this.$emit("input", this.form);
    },
    isInvalid: function() {
      return this.$v.$invalid;
    },
    previous: function() {
      this.$emit("previous");
    },
    submit: function() {
      var invalid = false;
      for (var i = 0; i < this.$refs.goalForms.length; i++) {
        this.$refs.goalForms[i].validate();
        if (this.$refs.goalForms[i].$v.$invalid) {
          invalid = true;
        }
      }

      if (!invalid) {
        this.createGoals({
          goals: this.goals,
          asuriteId: this.asuriteId
        }).then(response => {
          if (response) {
            this.$emit("submitted");
          }
        });
      }
    },
    initGoals: function() {
      var i = 0;
      if (!this.goals.length) {
        for (i = 0; i < this.total; i++) {
          this.goals.push({
            goalId: 0,
            studentOpportunityId: this.studentOpportunityId,
            text: ""
          });
        }
      }
    },
    updateStudentOpportunityId: function() {
      var i = 0;
      if (this.goals.length) {
        for (i = 0; i < this.total; i++) {
          this.goals[i].studentOpportunityId = this.studentOpportunityId;
        }
      }
    }
  },

  watch: {
    studentOpportunityId: function() {
      // this.goals = [];
      // this.$nextTick();
      if (this.studentOpportunityId) {
        // this.emptyGoals().then(() => {
        //   this.updateStudentOpportunityId();
        // });
        this.updateStudentOpportunityId();
      }
    }
  },

  created() {
    this.initGoals();
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
